import { DisplayMarket, DisplayMarketAsset } from "@silo/types";
import { ReactNode } from "react";
import { cn } from "../../utils/class-names";
import { TokenContext } from "../token-context";
import { asCompactUsd } from "@silo/utils";
import { isNotNullable } from "effect/Predicate";

interface AvailableToBorrowProps {
  className?: string;
  market: DisplayMarket;
  tokenLogo: ReactNode;
}

export function AvailableToBorrow({
  className,
  market,
  tokenLogo,
}: AvailableToBorrowProps): JSX.Element {
  const {
    baseAsset,
    bridgeAssets: [firstBridgeAsset, secondBridgeAsset],
  } = market;

  const showBase =
    baseAsset.liquidityUsd > 0n || baseAsset.depositMode !== "protectedOnly";

  const showSecondBridge = isNotNullable(secondBridgeAsset);

  return (
    <div
      className={cn("flex items-center gap-4 font-mono text-white", className)}
    >
      {showBase && <AssetLiquidity asset={baseAsset} tokenLogo={tokenLogo} />}

      <AssetLiquidity asset={firstBridgeAsset} tokenLogo={tokenLogo} />

      {showSecondBridge && (
        <AssetLiquidity asset={secondBridgeAsset} tokenLogo={tokenLogo} />
      )}
    </div>
  );
}

interface AssetLiquidityProps {
  asset: DisplayMarketAsset;
  tokenLogo: ReactNode;
}

function AssetLiquidity({
  asset,
  tokenLogo,
}: AssetLiquidityProps): JSX.Element {
  const { chainKey, tokenAddress, liquidityUsd } = asset;

  return (
    <div
      data-cy="available-to-borrow"
      className="flex gap-1 font-medium text-sm items-center w-[80px] text-right"
    >
      <TokenContext.Provider value={{ chainKey, tokenAddress }}>
        {tokenLogo}
      </TokenContext.Provider>

      <div className="text-right">{asCompactUsd(liquidityUsd)}</div>
    </div>
  );
}
